import React from 'react';
import Layout from '../components/Layout';
import CardContent from '../components/CardContent';

const Blog = () => {
  return (
    <Layout>
      <CardContent />
    </Layout>
  );
};

export default Blog;
